var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5719 14.287C28.5719 21.5025 23.2233 27.4678 16.2751 28.4358C15.6254 28.5259 14.9607 28.573 14.286 28.573C13.5072 28.573 12.7424 28.5109 11.9976 28.3908C5.19545 27.2956 0 21.3974 0 14.287C0 6.39671 6.3967 0 14.287 0C22.1772 0 28.5739 6.39671 28.5739 14.287H28.5719Z",
    fill: "#1877F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0377 10.4469V13.5591H19.8877L19.2781 17.7515H16.0377V27.4106C15.388 27.5007 14.7233 27.5478 14.0486 27.5478C13.2698 27.5478 12.505 27.4857 11.7602 27.3656V17.7515H8.20947V13.5591H11.7602V9.75114C11.7602 7.38866 13.6752 5.47266 16.0387 5.47266V5.47466C16.0457 5.47466 16.0517 5.47266 16.0587 5.47266H19.8887V9.09846H17.3861C16.6423 9.09846 16.0387 9.70209 16.0387 10.4459L16.0377 10.4469Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.833583c67e5de9a3029205637fb68155.svg";
export { ForwardRef as ReactComponent };